import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { Loading } from "../components/Loading";
import { makeStyles, Box } from "@material-ui/core";
import { CallbackAction } from "../components/CallbackAction";
import { SignUpAction } from "../components/SignUpAction";
import { store } from "../store";

export const CallToAction: FC = observer(() => {
  const classes = styles();
  const { appLoading } = store;

  if (appLoading) return <Loading text="Loading..." />;

  return (
    <Box className={classes.container}>
      <CallbackAction />
      <SignUpAction />
    </Box>
  );
});

const styles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    flex: 1,
    borderRadius: 15,
    marginBottom: 20,
    margin: "0px 20px",
    [theme.breakpoints.up("md")]: {
      borderRadius: 0,
      padding: 50,
    },
  },
  innerContainer: {
    [theme.breakpoints.up("md")]: {
      maxWidth: 600,
      margin: "0 auto",
    },
  },
  message: {
    display: "flex",
    justifyContent: "center",
  },
  loaderContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  loader: {
    marginTop: 20,
  },
}));
